export default{
    restrack_order: "تتبع الطلب",
restrack_placed: "تم تقديم الطلب",
restrack_confirmed: "تم تأكيد الطلب",
restrack_delivery: "قيد التوصيل",
restrack_delivered: "تم التسليم",

resdelivery_partner: "مندوب التوصيل",
resnot_assigned: "لم يتم التعيين",
reseta: "وقت الوصول المتوقع",

resorder_progress: "مراحل الطلب",

ressupport: "الدعم",
rescall_driver: "اتصال بالمندوب",
reswhatsapp_driver: "واتساب المندوب",
resdriver_not_assigned: "لم يتم تعيين مندوب بعد",

resnavigate: "التوجيه",
reslive_location: "الموقع المباشر",
reswaiting_driver_location: "بانتظار موقع المندوب...",
reslast_updated: "آخر تحديث",
}